import { gql } from "@apollo/client";

const ABANDON_DOWNLOAD_MUTATION = gql`
  mutation save_download($id: String!, $status: String!) {
    save_download(id: $id, download: { status: $status }) {
      ok
    }
  }
`;

const ABANDON_UPLOAD_MUTATION = gql`
  mutation save_upload($id: String!, $status: String!) {
    save_upload(id: $id, upload: { status: $status }) {
      ok
    }
  }
`;

export { ABANDON_DOWNLOAD_MUTATION, ABANDON_UPLOAD_MUTATION };
